import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import ProtectedRoute from "./ProtectedRoute";
import Layout from "../components/layouts/Layout";
import LoginPage from "../pages/LoginPage";
import OrderDetailsPage from "../pages/OrderDetailsPage";
import UserManagementPage from "../pages/UserManagementPage";
import RolesAndPermissionsPage from "../pages/RolesAndPermissionsPage";
import InventoryManagementPage from "../pages/InventoryManagementPage";
import NotificationsPage from "../pages/NotificationsPage";
import Orders from "../pages/Orders";
import UnauthorizedPage from "../pages/UnauthorizedPage";
import ProfilePage from "../pages/ProfilePage";
import RedirectToDashboard from "./RedirectToProperPage";
import VendorManagementPage from "../pages/VendorManagementPage";
import TableManagementPage from "../pages/TableManagementPage";
import DashboardPage from "../pages/DashboardPage";
import StaffSchedulePage from "../pages/StaffSchedulePage";
import { PERMISSIONS } from "../utils/permissions";
import LocationManagementPage from "../pages/LocationManagementPage";

const AppRoutes: React.FC = () => {
  return (
    <Routes>
      {/* Public Route */}
      <Route path="/" element={<RedirectToDashboard />} />
      <Route path="/login" element={<LoginPage />} />

      {/* Protected Routes (Inside Layout) */}
      <Route element={<ProtectedRoute />}>
        <Route element={<Layout />}>
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/orders" element={<Orders />} />
          <Route path="/orders/:orderId" element={<OrderDetailsPage />} />
          <Route path="/not-found" element={<h2>404 Not Found</h2>} />

          {/* User Management - Requires VIEW_USERS permission */}
          <Route
            path="/user-management"
            element={
              <ProtectedRoute requiredPermissions={[PERMISSIONS.VIEW_USERS]} />
            }
          >
            <Route index element={<UserManagementPage />} />
          </Route>
          {/* Location Management - Requires VIEW_LOCATIONSpermission */}
          <Route
            path="/locations"
            element={
              <ProtectedRoute
                requiredPermissions={[PERMISSIONS.VIEW_LOCATIONS]}
              />
            }
          >
            <Route index element={<LocationManagementPage />} />
          </Route>

          {/* Roles & Permissions - Requires VIEW_ROLES permission */}
          <Route
            path="/roles-permission"
            element={
              <ProtectedRoute requiredPermissions={[PERMISSIONS.VIEW_ROLES]} />
            }
          >
            <Route index element={<RolesAndPermissionsPage />} />
          </Route>

          {/* Staff Scheduling - Requires VIEW_SCHEDULES permission */}
          <Route
            path="/staff-scheduling"
            element={
              <ProtectedRoute
                requiredPermissions={[PERMISSIONS.VIEW_SCHEDULES]}
              />
            }
          >
            <Route index element={<StaffSchedulePage />} />
          </Route>

          {/* Inventory - Requires VIEW_INVENTORY permission */}
          <Route
            path="/inventory"
            element={
              <ProtectedRoute
                requiredPermissions={[PERMISSIONS.VIEW_INVENTORY]}
              />
            }
          >
            <Route index element={<InventoryManagementPage />} />
          </Route>

          {/* Vendors - Requires VIEW_VENDORS permission */}
          <Route
            path="/vendors"
            element={
              <ProtectedRoute
                requiredPermissions={[PERMISSIONS.VIEW_VENDORS]}
              />
            }
          >
            <Route index element={<VendorManagementPage />} />
          </Route>

          {/* Table Management - Requires VIEW_TABLES permission */}
          <Route
            path="/table-setup"
            element={
              <ProtectedRoute requiredPermissions={[PERMISSIONS.VIEW_TABLES]} />
            }
          >
            <Route index element={<TableManagementPage />} />
          </Route>

          {/* Stock Availability - Requires VIEW_INVENTORY permission */}
          <Route
            path="/stock-availability"
            element={
              <ProtectedRoute
                requiredPermissions={[PERMISSIONS.VIEW_INVENTORY]}
              />
            }
          >
            <Route index element={<h2>Stock Availability</h2>} />
          </Route>

          {/* Any Logged-in User Can Access Profile & Notifications */}
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/notifications" element={<NotificationsPage />} />
        </Route>
      </Route>

      {/* Unauthorized Access Page */}
      <Route path="/unauthorized" element={<UnauthorizedPage />} />

      {/* Catch-All 404 Page */}
      <Route path="*" element={<Navigate to="/not-found" />} />
    </Routes>
  );
};

export default AppRoutes;
